import React from "react";
import {
  FlexGrid,
  theme,
  DefaultErrorComponent,
  formatCurrency,
  displayErrorMessage,
} from "@clearabee/ui-library-native";
import { Checkboxes } from "./Checkboxes";
import { ProductDetailsSubmit } from "components/ProductDetailsSubmit/ProductDetailsSubmit";
import { useTranslation } from "react-i18next";
import { AddToBasketProps } from "./AddToBasket.types";
import { buildErrorsList } from "lib/utils";

export const AddToBasket = ({
  hasSurcharges,
  hasProhibitedItems,
  categorySku,
  price,
  isValid,
  submitCount,
  disabled,
  error,
  formErrors,
  isLoading,
  onSubmit,
}: AddToBasketProps): React.ReactElement => {
  const [translate] = useTranslation();

  const Errors = (): React.ReactElement => (
    <>
      {!isValid &&
        submitCount > 0 &&
        !!formErrors &&
        !!Object.keys(formErrors)?.length && (
          <DefaultErrorComponent
            basicMessage={translate("hwa.screens.productDetails.formErrors")}
            message={Object.entries(buildErrorsList(formErrors))
              .map(([key, value]) => `${key}: ${value}`)
              .join("\n")}
          />
        )}
      {displayErrorMessage(error, (props) => (
        <DefaultErrorComponent
          {...props}
          styles={{
            marginTop: theme.spacing.large,
            paddingBottom: theme.spacing.xsmall,
          }}
          basicMessage={translate("hwa.screens.productDetails.basketError")}
        />
      ))}
    </>
  );

  return (
    <>
      <FlexGrid>
        {(hasSurcharges || hasProhibitedItems) && (
          <FlexGrid.Cell base="100%" medium="50%">
            <Checkboxes categorySku={categorySku} />
          </FlexGrid.Cell>
        )}
        <FlexGrid.Cell base="100%" medium="50%">
          <ProductDetailsSubmit
            onSubmit={onSubmit}
            isLoading={isLoading}
            disabled={disabled}
            paymentRequired={!!price}
          >
            {price ? formatCurrency(price) : undefined}
          </ProductDetailsSubmit>
        </FlexGrid.Cell>
      </FlexGrid>
      <Errors />
    </>
  );
};
